module.exports = __webpack_public_path__ + "static/media/arch2.c582dce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch2.jpg
// module id = 5789
// module chunks = 0